import React from 'react';
import './VerticalProduct.scss';
const VerticalProduct = ({
  picture,
  heading,
  text,
  button,
  badgeWhite,
  badgeOrange,
  badgeRed,
  ...rest
}) => {
  if (!picture && !heading && !text && !button) {
    return false;
  }
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: "verticalProduct"
  }, rest), (badgeWhite || badgeOrange || badgeRed) && /*#__PURE__*/React.createElement("div", null, badgeWhite && /*#__PURE__*/React.createElement("span", {
    className: "badge-white"
  }, badgeWhite), badgeOrange && /*#__PURE__*/React.createElement("span", {
    className: "badge-orange"
  }, badgeOrange), badgeRed && /*#__PURE__*/React.createElement("span", {
    className: "badge-red"
  }, badgeRed)), /*#__PURE__*/React.createElement("img", {
    src: picture.src,
    loading: "lazy"
  }), heading && /*#__PURE__*/React.createElement("h3", null, heading), button && /*#__PURE__*/React.createElement("a", {
    rel: "noopener noreferrer",
    target: "_blank",
    className: "verticalProduct_btn",
    href: button.href
  }, button.label));
};
export default VerticalProduct;